var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('error',{attrs:{"err":_vm.error},on:{"update:err":function($event){_vm.error=$event}}}),(_vm.loading)?_c('spinner'):[_c('form-generator',{attrs:{"elements":_vm.elements,"data":_vm.profile,"handleUpdate":({ key }, value) => (_vm.profile[key] = value)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }